<template>
<div>
  <div class="row">
    <div class="col-md-12 intro">
      <h4>Compartilhe nossos Descontos do Bem</h4>
      <span>Compras originadas desse link irão gerar valores que serão retornados em benefício do projeto.</span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 inputbox">
      <input id="textbutton" readonly type="text" class="form-control" v-model="content" />
      <button class="btn btn-copy" v-on:click.stop.prevent="copyToClipboard()">Copiar</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 intro">
      <h4>Botão de Descontos</h4>
      <span>Copie o código abaixo e insira no site de sua Organização Social ou blog.
        Ao clicar em nosso botão "Contribuir com Click2giv" os visitantes de seu site e blog
        serão direcionados para a página de meios de pagamentos vinculados à sua Organização
        ou campanha publicada na click2giv.</span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 textbox">
      <textarea id="textbuttondescontos" readonly class="form-control" v-model="contentDescontos"></textarea>
      <button class="btn" v-on:click.stop.prevent="copyDescontosToClipboard()">Copiar</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3">
      <h4>Vitrine</h4>
      <span>Adicione uma imagem para a Loja Oficial do Projeto.</span>
    </div>

    <div class="col-md-9">
      <div class="photo-container row">
        <div class="col-md-8">
          <img v-on:click.stop.prevent="selectImage()" :src="image"/>
          <input ref="uploadBtn" class="input-photo" type="file" @change="uploadImage" />
        </div>
        <div class="col-md-4" v-if="!isUploadingImage">
          <span>Clique na imagem ao lado para adicionar uma nova foto.</span>
          <span>Tamanho recomendado 1920x700. Max 2,5MB</span>
        </div>
        <div class="col-md-4" v-else>
          <span>Aguarde...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-8">
      <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{msg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
        {{successMsg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="col-md-4">
      <button class="btn btn-save" v-on:click.stop.prevent="saveStore()">Salvar Loja</button>
    </div>
  </div>
</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'ProjectButton',
  props: ['project'],
  components: {
    VueEditor
  },
  data(){
    return {
      msg: '',
      successMsg: '',
      showMsg: false,
      showSuccessMsg: false,
      content: '',
      page: 'button',
      image: null,
      isUploadingImage: false,
      contentDescontos: ''
    }
  },
  mounted(){
    this.content = 'https://click2giv.com/d/' + this.project.slug;
    this.image = (this.project.ProjectStore && this.project.ProjectStore.image) ? this.project.ProjectStore.image : 'https://via.placeholder.com/500x220?text=Sem+Foto';
    this.contentDescontos = '<!-- INICIO DO BOTAO DESCONTOS DO BEM -->' +
      '<form action="https://click2giv.com/d/' + this.project.slug + '" method="get">' +
      '<input type="image" src="https://click2giv.com/images/botao_contribua.png" name="submit" alt="Contribua com os projetos da click2giv e mude vidas." />' +
      '</form><!-- FINAL DO BOTAO DESCONTOS DO BEM -->';
  },
  methods: {
    copyToClipboard(){
      var copyText = document.getElementById("textbutton");
      copyText.select();
      document.execCommand("copy");
    },
    copyDescontosToClipboard(){
      var copyText = document.getElementById("textbuttondescontos");
      copyText.select();
      document.execCommand("copy");
    },
    selectImage(){
      this.$refs.uploadBtn.click();
    },
    uploadImage(e){
      this.image = 'https://via.placeholder.com/500x220?text=Carregando...';
      e.preventDefault();
      this.isUploadingImage = true;
      var file = e.target.files[0]
      var reader = new FileReader();
      var $this = this;
      reader.addEventListener('loadend', (e) => {
        $this.$http.post(API.Projects.updateProject + this.project.ProjectId, {page: 'uploadDescontosImage', fileName: file.name, fileType: file.type}, {headers: auth.getHeaders()})
        .then((res) => {
          return $this.$http.put(res.body.uploadUrl, new Blob([reader.result], {type: file.type}), {headers: {'Content-Type': file.type, 'x-amz-acl': 'authenticated-read'}});
        })
        .then((res) => {
          var image = res.url.split('?');
          $this.image = image[0] + '?' + new Date().getTime();
          $this.$forceUpdate();
          $this.isUploadingImage = false;
        })
      })
      reader.readAsArrayBuffer(file);
    },
    saveStore(){
      this.$emit('showloading');
      this.hideMessage();
      this.$http.post(API.Projects.updateProject + this.project.ProjectId, {image: this.image, page: 'store'},
        {headers: auth.getHeaders()}).then((res) => {
        if(res.body.success === true){
          this.successMsg = res.body.message;
          this.showSuccessMsg = true;
          this.showVideo = true;
          this.$emit('reload');
        }else{
          this.showMessage(res.body.message);
        }
        this.$emit('hideloading');
      }, (err) => {
        this.showMessage(err.body.message);
        this.$emit('hideloading');
      });
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.inputbox{
  position: relative;
  height: 100px;
  margin-top: 20px;
}
.textbox{
  position: relative;
  height: 230px;
  margin-top: 20px;

  .btn{
    position: absolute;
    right: 20px;
    bottom: 65px;
    font-size: 14px !important;
    background-color: #00AE39;
    color: #fff;
  }
}
textarea{
  height: 170px;
  resize: none;
}
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .photo-container{
      img{
        width: 100%;
        cursor: pointer;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.input-photo{
  display: none;
}
.btn-copy{
  position: absolute;
  right: 20px;
  bottom: 10px;
  font-size: 16px !important;
  background-color: #00AE39;
  color: #fff;
}
.btn-save{
  font-size: 22px !important;
  display: block;
  color: #fff;
  background-color: #00AE39;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/manage-project/LinkDescontos.vue